import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from 'react-router-dom';
import AnimatedWrapper from "../components/AnimatedWrapper";
import ProgressBar from "../components/ProgressBar";
import {moisturizedSkin} from "../config/data"
import { useUser } from "../context/useInfo";
import amplitude from "../utils/amplitude";
import { useEffect } from "react";



export default function Page18() {
  const navigate = useNavigate();
  const {updateUserData} = useUser()

  useEffect(() => {
        if(process.env.NODE_ENV === "production"){
              amplitude.track('Quiz Step Open', {
            step_number:18,
          });
            }
  }, [])

  const nextStep = (option) => {
    updateUserData({moisturizedSkin: option})
    if(process.env.NODE_ENV === "production"){
      amplitude.track('Quiz Step Complete', {
            step_number: 18, 
            answers:{moisturizedSkin: option}
          });

    }
    navigate('/quiz19')
  }
      const stepBack = () => {
        updateUserData({moisturizedSkin: ""})
    navigate('/quiz17')
  }
  return (
  <AnimatedWrapper>

    {/* Top bar with back button and progress */}
    <div className="flex items-center space-x-2 pt-4">
      <button className="text-gray-600" onClick={() => stepBack()}>
        <IoIosArrowBack size={24} />
      </button>
      <ProgressBar />
    </div>

    {/* Main content aligned to top */}
    <div className="mt-8">
      {/* Question */}
      <h2 className="text-center text-lg font-semibold mb-2">
        Do you think your skin is well moisturized?
      </h2>
      <p className="text-center text-sm text-gray-500 mb-6">
        People often confuse dry and dehydrated skin. Our analysis will help you get to know your skin better.
      </p>

      {/* Options */}
      <div className="space-y-4">
        {moisturizedSkin.map((option) => (
          <button
            key={option}
            onClick={() => nextStep(option)}
            className="flex items-center justify-between w-full py-3 px-4 bg-white rounded-lg shadow-sm 
             sm:hover:shadow-md transition border border-gray-100 sm:hover:border-gray-200 
             cursor-pointer"
          >
            {option}
          </button>
        ))}
      </div>
    </div>

    {/* Optional: Add empty space at bottom if needed */}
    <div className="flex-grow"></div>
  </AnimatedWrapper>

  );
}